<div *ngIf="visible"
     data-testid="instructor-preview-metadata-strip"
     class="instructor-preview-metadata-strip flex items-center justify-between gap-3 rounded-xl border border-base-300 bg-base-200 px-4 py-2.5">
  <div class="flex items-center gap-3 text-sm flex-wrap">
    <span *ngIf="overrideActive"
          data-testid="instructor-preview-override-chip"
          class="badge badge-warning badge-outline gap-1">
      <span class="w-1.5 h-1.5 rounded-full bg-warning"></span>
      Override Active
    </span>
    <span *ngIf="videoRequired"
          data-testid="instructor-preview-module-rule"
          class="text-base-content/60 text-xs">
      Module rule:
      <span class="text-base-content/80">video required before quiz</span>
    </span>
  </div>
  <span class="text-[11px] uppercase tracking-[0.18em] text-base-content/50 shrink-0">Instructor-only</span>
</div>
